import { isPlatformBrowser } from '@angular/common';
import { Component, DestroyRef, inject, Inject, input, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { SearchService } from '@app/services/search.service';
import { debounceTime, filter, startWith, forkJoin } from 'rxjs';
import { PeakworkService } from '@app/services/peakwork.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { I18nService } from '@app/services/i18n.service';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { NavigationExtras, Router } from '@angular/router';
import { EncryptionService } from '@app/services/encyption.service';
import { MediaService } from '@app/services/media.service';
@Component({
    selector: 'clever-reiseziel',
    templateUrl: './reiseziel.component.html',
    styleUrls: ['./reiseziel.component.scss'],
    standalone: false
})
export class ReisezielComponent implements OnInit {
    mode = input<string>('');
    type = input<string>('');
    completion = input<any>(null);

    isBrowser = signal<boolean>(false);
    showModal = signal<boolean>(false);
    focus = signal<boolean>(false);
    loading = signal<boolean>(false);

    suffix = signal<string>('Pauschalreisen');
    zielText = signal<string>('Beliebig');

    destroyRef = inject(DestroyRef);

    searchObj = signal<any[]>([]);
    mySearchControl = new FormControl();
    partner = signal<Partner>(null);
    ops = signal<string>('');

    defaultdatas = [
        {
            code: '851',
            name: 'Kanarische Inseln',
            superRegion: 'Atlantische Inseln, Spanien',
            type: 3
        },
        {
            code: '100',
            name: 'Malediven',
            superRegion: 'Indischer Ozean, Malediven',
            type: 3
        },
        {
            code: '100000',
            name: 'Balearen',
            superRegion: 'Mittelmeerraum, Spanien',
            type: 3
        },
        {
            code: '100002',
            name: 'Griechische Inseln',
            superRegion: 'Südosteuropa, Griechenland',
            type: 3
        }
    ];

    defaultdatasrail = [
        {
            code: '100003',
            name: 'Deutschland Nord',
            type: 3
        },
        {
            code: '100005',
            name: 'Deutschland Ost',
            type: 3
        },
        {
            code: '100006',
            name: 'Deutschland Süd',
            type: 3
        },
        {
            code: '100004',
            name: 'Deutschland West',
            type: 3
        },
    ];

    overlaypos: ConnectedPosition[] = [
        {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top',
        }
    ];

    constructor(
        protected mediaService: MediaService,
        protected router: Router,
        protected encservice: EncryptionService,
        protected searchService: SearchService,
        protected hotelService: HotelFiltersService,
        protected guardService: AuthGuardService,
        protected peakworkservie: PeakworkService,
        protected i18service: I18nService,
        @Inject(PLATFORM_ID) protected platformId: any
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngOnInit(): void {
        if (this.type() === 'hotelonly') {
            this.suffix.set('Hotel');
        }
        if (this.type() === 'railtravel') {
            this.suffix.set('Bahnreisen');
        }
        this.initPartner();
        this.initFilterSub();
        this.initSearchChange();
    }

    initPartner(): void {
        this.guardService.getPartner$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(partner => {
            if (partner?.partnerid?.length > 0) {
                this.partner.set(partner);
                for (let i = 0; i < this.partner()?.agenturen?.length; i++) {
                    if (this.partner()?.agenturen[i]?.aktiv) {
                        this.ops.set(this.ops() + this.partner()?.agenturen[i]?.code + ',');
                    }
                }
            }
        });
    }

    async initFilterSub() {
        this.hotelService.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((filter: ParamFilters) => {
            if (filter?.pauschalreiseResult?.data?.name?.length > 0) {
                if (this.zielText() !== filter.pauschalreiseResult.data.name) {
                    this.zielText.set(filter.pauschalreiseResult.data.name);
                }
            } else {
                this.zielText.set('Beliebig');
            }
        });
    }

    detectPast(ev) {
        ev.stopPropagation();
        ev.preventDefault();
        this.mySearchControl.setValue(' ', { emitEvent: true, emitViewToModelChange: true });
        this.mySearchControl.setValue(ev.clipboardData.getData('text'), { emitEvent: true, emitViewToModelChange: true });
    }

    initSearchChange(): void {
        this.mySearchControl.valueChanges.pipe(
            startWith(''),
            debounceTime(100),
            filter(value => (typeof value === 'string' && value?.length > 0)),
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(value => {
            this.loading.set(true);
            this.getRes(value);
        });
    }

    async getRes(value) {
        this.searchObj.set([]);
        let tvangebot = null;
        let peakworkobs = null;
        let trafficsobs = null;



        if(!this.partner().nosktv) {
            const tvfilter = {
                searchtarget: value,
                limit: 20
            };
    
            tvangebot = this.searchService.searchEntries(tvfilter, 'completions/completionTVAngebote');
        }

        if (this.partner().peakwork?.active && this.partner().peakwork?.apikey?.length > 0) {
            const peakfilter = {
                keyWord: {
                    value: value,
                    includes: [
                        'hotel',
                        'region',
                        'country',
                        'city'
                    ]
                },
                authKey: this.partner().peakwork.apikey,
                language: this.i18service.lang,
                resultsPerGroup: 10,
                requestType: (this.type() === 'pauschal' ? 'PACKAGE' : 'HOTEL'),
                authKeyFilter: false
            };

            peakworkobs = this.peakworkservie.request({ filter: peakfilter }, 'completion');
            // console.log(peakfilter)
        }
        if (this.partner().traffics?.aktiv && this.partner().traffics?.licence?.length > 0) {
            const myobj = {
                searchValue: value,
                language: this.i18service.lang,
                licence: this.partner().traffics.licence,
                productType: this.type(),
                subTypeRegion: true,
                subTypeLocation: true,
                subTypeGiataHotel: true,
                subTypeTrainStation: false,
                subTypeCountry: true,
                tourOperatorList: this.ops(),
                limit: 10
            };
            trafficsobs = this.searchService.searchEntries(
                myobj, 'completions');
        }

        const obs: any = {};
        if (peakworkobs) {
            obs.peakwork = peakworkobs;
        }
        if (trafficsobs) {
            obs.traffics = trafficsobs;
        }
        if (tvangebot) {
            obs.tvangebot = tvangebot;
        }
        forkJoin(obs).pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((res: any) => {
            // console.log(res)
            this.mergDatas(res);
        });
    }

    async mergDatas(res) {
        const alldatas = [];

        for (let i = 0; i < res?.traffics?.length; i++) {
            alldatas.push({
                name: res.traffics[i].name,
                code: res.traffics[i].code,
                location: res.traffics[i]?.location?.name,
                region: res.traffics[i]?.region?.name,
                superRegion: res.traffics[i]?.superRegion?.name,
                traffics: true,
                type: res.traffics[i].type
            });
        }

        for (let i = 0; i < res?.tvangebot?.length; i++) {
            alldatas.push({
                name: res.tvangebot[i].name,
                code: res.tvangebot[i].id,
                region: res.tvangebot[i].location,
                tv: true,
                type: 5
            });
        }

        for (let i = 0; i < res?.peakwork?.keyWordGroups?.length; i++) {
            if (res.peakwork?.keyWordGroups[i].name === 'region') {
                for (let j = 0; j < res.peakwork?.keyWordGroups[i].keyWords.length; j++) {
                    const index = this.checkinarray(alldatas, res.peakwork?.keyWordGroups[i].keyWords[j]);
                    if (index >= 0) {
                        alldatas[index].data.peakwork = true;
                    } else {
                        alldatas.push({
                            name: res.peakwork?.keyWordGroups[i].keyWords[j].name.split('<em>')?.[0],
                            code: res.peakwork?.keyWordGroups[i].keyWords[j].id,
                            superRegion: res.peakwork?.keyWordGroups[i].keyWords[j].name.split('<em>')?.[1]?.split('</em>')?.[0],
                            peakwork: true,
                            type: 3
                        });
                    }
                }
            }
            if (res.peakwork?.keyWordGroups[i].name === 'country') {
                for (let j = 0; j < res.peakwork?.keyWordGroups[i].keyWords.length; j++) {
                    const index = this.checkinarray(alldatas, res.peakwork?.keyWordGroups[i].keyWords[j]);
                    if (index >= 0) {
                        alldatas[index].data.peakwork = true;
                    } else {
                        alldatas.push({
                            name: res.peakwork?.keyWordGroups[i].keyWords[j].name,
                            code: res.peakwork?.keyWordGroups[i].keyWords[j].id,
                            peakwork: true,
                            type: 4
                        });
                    }
                }
            }
            if (res.peakwork?.keyWordGroups[i].name === 'hotel') {
                for (let j = 0; j < res.peakwork?.keyWordGroups[i].keyWords.length; j++) {
                    const index = this.checkinarray(alldatas, res.peakwork?.keyWordGroups[i].keyWords[j]);
                    if (index >= 0) {
                        alldatas[index].data.peakwork = true;
                    } else {
                        alldatas.push({
                            name: res.peakwork?.keyWordGroups[i].keyWords[j].name.split('<em>')?.[0],
                            code: res.peakwork?.keyWordGroups[i].keyWords[j].id,
                            superRegion: res.peakwork?.keyWordGroups[i].keyWords[j].name.split('<em>')?.[1]?.split('</em>')?.[0],
                            peakwork: true,
                            type: 1
                        });
                    }
                }
            }
            if (res.peakwork?.keyWordGroups[i].name === 'city') {
                for (let j = 0; j < res.peakwork?.keyWordGroups[i].keyWords.length; j++) {
                    const index = this.checkinarray(alldatas, res.peakwork?.keyWordGroups[i].keyWords[j]);
                    if (index >= 0) {
                        alldatas[index].data.peakwork = true;
                    } else {
                        alldatas.push({
                            name: res.peakwork?.keyWordGroups[i].keyWords[j].name.split('<em>')?.[0],
                            code: res.peakwork?.keyWordGroups[i].keyWords[j].id,
                            region: res.peakwork?.keyWordGroups[i].keyWords[j].name.split('<em>')?.[1]?.split('</em>')?.[0],
                            peakwork: true,
                            type: 2
                        });
                    }
                }
            }
        }
        if (alldatas?.length > 0) {
            alldatas.sort((a, b) => {
                return b.data?.name?.toLowerCase().localeCompare(a.data?.name?.toLowerCase());
            });
            this.searchObj.set(alldatas);
        }
        this.loading.set(false);
        // console.log(alldatas)
    }

    checkinarray(array, value): any {
        for (let i = 0; i < array.length; i++) {
            if (array[i].code === value.id) {
                return i;
            }
        }

        return -1;
    }

    openModal(): void {
        this.showModal.set(true);
        this.focus.set(true);
    }

    openModalMobile(): void {
        this.showModal.set(true);
        this.focus.set(true);
    }

    closeModal(): void {
        this.showModal.set(false);
    }

    closeModalMobile(): void {
        this.showModal.set(false);
    }

    clearText(ev): void {
        ev.stopPropagation();
        this.mySearchControl.setValue('');
        this.focus.set(false);
        setTimeout(() => {
            this.focus.set(true);
        }, 50);
    }

    selectValue(item): void {
        if (item.type === 5) {
            this.zielText.set('Bestellnummer: ' + item?.code);
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt({ extra: { orderId: item.code } }) }
            };
            const url = this.router.createUrlTree(['sktv'], navigationExtras).toString();
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('visibility', 'hidden');
            link.click();
        } else {
            this.zielText.set(item?.name);
            this.showModal.set(false);
            this.mySearchControl.setValue('');
            this.hotelService.pauschalreiseResult({
                peakwork: item.peakwork,
                type: item.type,
                data: {
                    name: item.name,
                    code: item.code
                }
            });
        }
    }

    async setSelection(item) {
        this.showModal.set(false);
        if (item?.link?.length > 0) {
            const link = document.createElement('a');
            link.href = item.link;
            link.setAttribute('visibility', 'hidden');
            link.click();
        } else {
            this.hotelService.onlySetRealParams(item.inputData?.realparams);
            this.hotelService.gotoUrl('');
        }
    }
}
